import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

export const Loading = <Loader size="m" my={256} mx="auto" />;
